import React, { useEffect, useState } from "react"
import { apiClient } from "../../../helpers/apiHelperV2"
import Image from "../Image/Image"
import LocationCarMakesRow from "../LocationLists/LocationCarMakesRow"
import { ContactPhone } from "../Meisterkachel/Contact"
import { ExternalLink } from "../form-elements/Link"

function ApsLocationTiles(){

    const [locations, setLocations] = useState([])

    useEffect(() => {
        const fetchLocations = async () => {
            try{
                let response = await apiClient.get("/api/v1/getLocationTiles")
                if(response?.data?.locations){
                    let locs = response?.data?.locations
                    locs.forEach(loc =>{
                        if(loc.hauptFabrikat && loc.nebenFabrikat){
                            loc.nebenFabrikat = loc.nebenFabrikat.filter(fabrikat => fabrikat != loc.hauptFabrikat)
                        }
                    })
                    locs.sort((a,b) => a.anschrift.firma.localeCompare(b.anschrift.firma))
                    setLocations(locs)
                }else{
                    console.error("No locations fetched")
                }
            } catch(error){
                console.error("Error while fetching locatons:", error)
            }
        }
        fetchLocations()
    },[])
    return (
        <section className="uk-section uk-section-default">
            <div className="uk-container">
                <div className="uk-grid uk-grid-small uk-grid-match uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m" data-uk-grid="">
                    {locations.map(location => (
                        <div className="uk-padding-small">
                            <div className="uk-flex uk-flex-column uk-padding-small" style={{border: '1px solid #f1f1f1', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', borderRadius: '4px', height: '100%'}}>
                                <Image src={`https://techno-images.s3.eu-central-1.amazonaws.com/standort-images/${location.gesellschafterNr}/${location.standortNr}/Logo.jpg`} alt={`${location.anschrift.firma} Logo`} resizeHeight={30} />
                                <div className="uk-width-expand uk-margin-small-top">
                                        <LocationCarMakesRow location={location} height={20} />
                                    </div>
                                <div className="uk-padding-small">
                                    <div className="uk-text-bold">
                                        {location.anschrift.firma}
                                    </div>
                                    <div>
                                        <ContactPhone modifier="reset" phone={location.anschrift.telefon} className="uk-flex-left" hideArrow={false} ariaLabel={`${location.anschrift.telefon} ${location.anschrift.firma} anrufen`} />
                                    </div>
                                    <div>
                                        <ExternalLink
                                            to={`mailto:${location.anschrift?.email}`}
                                            category="Anfrage"
                                            action="Klick-Email"
                                            label={location.anschrift?.email}
                                        >
                                            <i className="fa fa-envelope-o uk-margin-small-right" /> {location.anschrift?.email}
                                        </ExternalLink>
                                    </div>
                                    <div>
                                        <ExternalLink
                                            to={location.url}
                                            label={location.shoplink}
                                            className="uk-button uk-button-secondary uk-margin-small-top"
                                            ariaLabel={`Zum Shop - ${location.anschrift.firma}`}
                                        >
                                            ZUM SHOP
                                        </ExternalLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
export default ApsLocationTiles